<template>
  <div class="software-item">
    <img
      class="software-icon"
      :src="software.iconUrl || 'https://dummyimage.com/48x48/595b75/fff'">
    <div class="software-name">{{ software.name }}</div>
  </div>
</template>

<script>
  export default {
    name: 'software-item',

    props: {
      software: {
        type: Object,
        // { name, iconUrl }
      }
    },

    data() {
      return {};
    }
  }
</script>

<style lang="scss" scoped>
  .software {
    position: relative;
  }

  .software-icon {
    display: block;
    width: 48px;
    height: 48px;
    margin: 0 auto 8px auto;
  }

  .software-name {
    text-align: center;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// index.vue?7a65fe2a